type BarChartProps = {
  bars: { x: string; y: number }[];
  loading?: boolean;
  empty?: boolean;
};

const BarChart = ({ bars, loading, empty }: BarChartProps) => {
  if (loading) return <div className="h-full animate-pulse rounded bg-gray-100" />;
  if (empty)
    return (
      <div className="h-full grid place-items-center text-sm text-gray-500">
        No data today
      </div>
    );
  return (
    <div className="h-full overflow-auto text-xs text-gray-700">
      {bars.map((b) => (
        <div key={b.x} className="flex items-center gap-2 py-1">
          <div className="w-40 truncate" title={b.x}>{b.x}</div>
          <div className="flex-1 h-3 rounded bg-gray-200">
            <div
              className="h-3 rounded bg-gray-700"
              style={{ width: `${Math.min(100, (b.y / Math.max(1, bars[0]?.y || 1)) * 100)}%` }}
              aria-valuenow={b.y}
            />
          </div>
          <div className="w-16 text-right tabular-nums">{b.y}</div>
        </div>
      ))}
    </div>
  );
};

export default BarChart;
